import { useCallback, useState } from 'react';
export var useIsScrolledUp = function (listRef) {
    var _a = useState(false), isScrolledUp = _a[0], setIsScrolledUp = _a[1];
    var update = useCallback(function () {
        if (listRef.current) {
            var _a = listRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            var scrolledUp = Math.ceil(scrollTop) < scrollHeight - clientHeight;
            setIsScrolledUp(scrolledUp);
        }
    }, [listRef.current, setIsScrolledUp]);
    return [isScrolledUp, update];
};
//# sourceMappingURL=isScrolledUpHook.js.map